import { render, staticRenderFns, recyclableRender, components } from "./clerkuser.vue?vue&type=template&id=64da2c6b&scoped=true&"
var renderjs
import script from "./clerkuser.vue?vue&type=script&lang=js&"
export * from "./clerkuser.vue?vue&type=script&lang=js&"
import style0 from "./clerkuser.vue?vue&type=style&index=0&id=64da2c6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da2c6b",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/store/part/clerkuser.vue"
export default component.exports